export const d002 = {
  json: {
    name: 'body',
    type: 'body',
    active: false,
    dropDown: true,
    editable: true,
    innerText: '',
    styles: {
      fontFamily: 'Ubuntu',
      marginLeft: '-2px',
      margin: '',
      width: '',
      color: 'rgba(0,0,0,1)',
      borderStyle: 'none',
    },
    childrens: [
      {
        type: 'block',
        active: false,
        editable: true,
        styles: {
          flexDirection: 'row',
          height: '100vh',
          width: '100%',
        },
        childrens: [
          {
            type: 'block',
            active: false,
            editable: true,
            styles: {
              height: '100%',
              backgroundSize: 'cover',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '',
              width: '50%',
            },
            childrens: [
              {
                type: 'heading',
                active: false,
                editable: true,
                innerText: 'HEADING',
                styles: {
                  color: 'rgba(0,0,0,1)',
                  fontSize: '32px',
                  fontWeight: '600',
                },
                css: 'position: relative;\nz-index:1;',
              },
              {
                type: 'paragraph',
                active: false,
                editable: true,
                innerText:
                  'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form',
                styles: {
                  color: 'rgba(0,0,0,1)',
                  textAlign: 'center',
                },
                css: 'position: relative;\nz-index:1;',
              },
              {
                type: 'video',
                src: 'https://videos.pexels.com/video-files/3755797/3755797-uhd_2732_1440_25fps.mp4',
                editable: true,
                active: true,
                styles: {
                  width: '100%',
                  height: '100%',
                },
                controls: false,
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                css: 'position: absolute;\ntop: 0;\nobject-fit: cover;',
              },
            ],
            dropDown: true,
            css: 'position: relative;',
          },
          {
            type: 'block',
            active: false,
            editable: true,
            styles: {
              height: '100%',
              padding: '26px',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              width: '50%',
            },
            childrens: [
              {
                type: 'block',
                active: false,
                editable: true,
                styles: {
                  borderRadius: '12px',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  borderColor: 'rgba(0,0,0,0.2)',
                  width: '80%',
                  paddingTop: '26px',
                  paddingBottom: '26px',
                  paddingLeft: '24px',
                  paddingRight: '24px',
                },
                childrens: [
                  {
                    type: 'heading',
                    active: false,
                    editable: true,
                    innerText: 'Create An Account',
                    styles: {
                      fontWeight: '600',
                      fontSize: '24px',
                      marginLeft: '',
                      marginTop: '',
                      marginBottom: '22px',
                      padding: '10px',
                    },
                  },
                  {
                    type: 'stepper',
                    active: false,
                    editable: true,
                    bgCompleteColor: '#3b82f6',
                    bgActiveColor: '#bfdbfe',
                    bgStepColor: '#e5e7eb',
                    textCompleteColor: '#ffffff',
                    textActiveColor: '#1d4ed8',
                    textStepColor: '#6b7280',
                    buttonContainerProps: {
                      type: 'block',
                      active: false,
                      editable: true,
                      styles: {
                        flexDirection: 'row',
                        marginTop: '32px',
                        paddingTop: '',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                      },
                    },
                    nextButtonProps: {
                      type: 'button',
                      innerText: 'Next',
                      editable: true,
                      active: false,
                      styles: {
                        width: '',
                        marginRight: '',
                        marginLeft: 'auto',
                        borderRadius: '12px',
                        paddingTop: '',
                        paddingLeft: '18px',
                        paddingRight: '18px',
                        backgroundColor: 'rgba(191,177,255,1)',
                        color: 'rgba(255,255,255,1)',
                      },
                    },
                    prevButtonProps: {
                      type: 'button',
                      innerText: 'Back',
                      editable: true,
                      active: false,
                      styles: {
                        paddingLeft: '18px',
                        paddingRight: '18px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(247,246,251,1)',
                      },
                    },
                    steps: [
                      {
                        type: 'block',
                        active: false,
                        editable: true,
                        stepLabel: 'Step 4',
                        styles: {
                          padding: '16px',
                        },
                        childrens: [
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Email',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                                inputName: 'email',
                              },
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'email',
                                id: 'email',
                                name: 'email',
                                inputType: 'email',
                                placeholder: 'Enter your email',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                            ],
                            dropDown: false,
                          },
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Phone',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                                inputName: 'phone',
                              },
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'phone',
                                id: 'email',
                                name: 'email',
                                inputType: 'tel',
                                placeholder: 'Enter your phone',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                            ],
                            dropDown: false,
                            styles: {
                              marginTop: '16px',
                            },
                          },
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            styles: {
                              marginTop: '16px',
                              marginLeft: '-10px',
                              marginRight: '-10px',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                            },
                            childrens: [
                              {
                                type: 'block',
                                active: false,
                                editable: true,
                                childrens: [
                                  {
                                    type: 'label',
                                    active: false,
                                    editable: true,
                                    innerText: 'Password',
                                    htmlFor: 'email',
                                    styles: {
                                      fontSize: '14px',
                                      paddingLeft: '6px',
                                      marginBottom: '3px',
                                    },
                                    inputName: 'password',
                                  },
                                  {
                                    type: 'input',
                                    active: false,
                                    editable: true,
                                    value: '',
                                    inputName: 'password',
                                    id: 'email',
                                    name: 'email',
                                    inputType: 'password',
                                    placeholder: 'Enter your password',
                                    required: true,
                                    styles: {
                                      borderRadius: '8px',
                                      fontSize: '16px',
                                      paddingLeft: '16px',
                                      paddingRight: '16px',
                                      borderStyle: 'solid',
                                      borderWidth: '1px',
                                      borderColor: 'rgba(0,0,0,0.36)',
                                      paddingTop: '6px',
                                      paddingBottom: '6px',
                                    },
                                  },
                                ],
                                dropDown: false,
                                styles: {
                                  marginTop: '',
                                  paddingLeft: '10px',
                                  paddingRight: '10px',
                                  width: '50%',
                                },
                              },
                              {
                                type: 'block',
                                active: false,
                                editable: true,
                                childrens: [
                                  {
                                    type: 'label',
                                    active: false,
                                    editable: true,
                                    innerText: 'Confirm Password',
                                    htmlFor: 'email',
                                    styles: {
                                      fontSize: '14px',
                                      paddingLeft: '6px',
                                      marginBottom: '3px',
                                    },
                                    inputName: 'confirmPassword',
                                  },
                                  {
                                    type: 'input',
                                    active: false,
                                    editable: true,
                                    value: '',
                                    inputName: 'confirmPassword',
                                    id: 'email',
                                    name: 'email',
                                    inputType: 'password',
                                    placeholder: 'Confirm your password',
                                    required: true,
                                    styles: {
                                      borderRadius: '8px',
                                      fontSize: '16px',
                                      paddingLeft: '16px',
                                      paddingRight: '16px',
                                      borderStyle: 'solid',
                                      borderWidth: '1px',
                                      borderColor: 'rgba(0,0,0,0.36)',
                                      paddingTop: '6px',
                                      paddingBottom: '6px',
                                    },
                                  },
                                ],
                                dropDown: false,
                                styles: {
                                  marginTop: '',
                                  paddingLeft: '10px',
                                  paddingRight: '10px',
                                  width: '50%',
                                },
                              },
                            ],
                            dropDown: false,
                          },
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'terms',
                                id: 'email',
                                name: 'email',
                                inputType: 'checkbox',
                                placeholder: 'Enter your phone',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Accept terms',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                                inputName: 'terms',
                              },
                            ],
                            dropDown: false,
                            styles: {
                              marginTop: '16px',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            },
                          },
                        ],
                        dropDown: true,
                      },
                      {
                        type: 'block',
                        active: false,
                        editable: true,
                        stepLabel: 'Step 2',
                        styles: {
                          padding: '16px',
                        },
                        childrens: [
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            styles: {
                              marginTop: '16px',
                              marginLeft: '-10px',
                              marginRight: '-10px',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'center',
                            },
                            childrens: [
                              {
                                type: 'block',
                                active: false,
                                editable: true,
                                childrens: [
                                  {
                                    type: 'label',
                                    active: false,
                                    editable: true,
                                    innerText: 'Date',
                                    htmlFor: 'email',
                                    styles: {
                                      fontSize: '14px',
                                      paddingLeft: '6px',
                                      marginBottom: '3px',
                                    },
                                    inputName: 'date',
                                  },
                                  {
                                    type: 'input',
                                    active: false,
                                    editable: true,
                                    value: '',
                                    inputName: 'date',
                                    id: 'email',
                                    name: 'email',
                                    inputType: 'date',
                                    placeholder: 'Enter your password',
                                    required: true,
                                    styles: {
                                      borderRadius: '8px',
                                      fontSize: '16px',
                                      paddingLeft: '16px',
                                      paddingRight: '16px',
                                      borderStyle: 'solid',
                                      borderWidth: '1px',
                                      borderColor: 'rgba(0,0,0,0.36)',
                                      paddingTop: '6px',
                                      paddingBottom: '6px',
                                    },
                                  },
                                ],
                                dropDown: false,
                                styles: {
                                  marginTop: '',
                                  paddingLeft: '10px',
                                  paddingRight: '10px',
                                  width: '50%',
                                },
                              },
                              {
                                type: 'block',
                                active: false,
                                editable: true,
                                childrens: [
                                  {
                                    type: 'label',
                                    active: false,
                                    editable: true,
                                    innerText: 'Time',
                                    htmlFor: 'email',
                                    styles: {
                                      fontSize: '14px',
                                      paddingLeft: '6px',
                                      marginBottom: '3px',
                                    },
                                    inputName: 'time',
                                  },
                                  {
                                    type: 'input',
                                    active: false,
                                    editable: true,
                                    value: '',
                                    inputName: 'time',
                                    id: 'email',
                                    name: 'email',
                                    inputType: 'time',
                                    placeholder: 'Confirm your password',
                                    required: true,
                                    styles: {
                                      borderRadius: '8px',
                                      fontSize: '16px',
                                      paddingLeft: '16px',
                                      paddingRight: '16px',
                                      borderStyle: 'solid',
                                      borderWidth: '1px',
                                      borderColor: 'rgba(0,0,0,0.36)',
                                      paddingTop: '6px',
                                      paddingBottom: '6px',
                                    },
                                  },
                                ],
                                dropDown: false,
                                styles: {
                                  marginTop: '',
                                  paddingLeft: '10px',
                                  paddingRight: '10px',
                                  width: '50%',
                                },
                              },
                            ],
                            dropDown: false,
                          },
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Date',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                                inputName: 'dateTime',
                              },
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'dateTime',
                                id: 'email',
                                name: 'email',
                                inputType: 'datetime-local',
                                placeholder: 'Enter your email',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                            ],
                            dropDown: false,
                            styles: {
                              marginTop: '16px',
                            },
                          },
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Amount',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                                inputName: 'amount',
                              },
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'amount',
                                id: 'email',
                                name: 'email',
                                inputType: 'number',
                                placeholder: 'Enter your phone',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                            ],
                            dropDown: false,
                            styles: {
                              marginTop: '16px',
                            },
                          },
                        ],
                        dropDown: false,
                      },
                      {
                        type: 'block',
                        active: false,
                        editable: true,
                        stepLabel: 'Step 3',
                        styles: {
                          padding: '16px',
                        },
                        childrens: [
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Image',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '3px',
                                },
                                inputName: 'image',
                              },
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'image',
                                id: 'email',
                                name: 'email',
                                inputType: 'file',
                                placeholder: 'Enter your email',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                },
                              },
                            ],
                            dropDown: false,
                          },
                          {
                            type: 'block',
                            active: false,
                            editable: true,
                            childrens: [
                              {
                                type: 'input',
                                active: false,
                                editable: true,
                                value: '',
                                inputName: 'color',
                                id: 'email',
                                name: 'email',
                                inputType: 'color',
                                placeholder: 'Enter your phone',
                                required: true,
                                styles: {
                                  borderRadius: '8px',
                                  fontSize: '16px',
                                  paddingLeft: '16px',
                                  paddingRight: '16px',
                                  borderStyle: 'solid',
                                  borderWidth: '1px',
                                  borderColor: 'rgba(0,0,0,0.36)',
                                  paddingTop: '6px',
                                  paddingBottom: '6px',
                                  marginRight: '10px',
                                },
                              },
                              {
                                type: 'label',
                                active: false,
                                editable: true,
                                innerText: 'Color',
                                htmlFor: 'email',
                                styles: {
                                  fontSize: '14px',
                                  paddingLeft: '6px',
                                  marginBottom: '',
                                  marginTop: '',
                                },
                                inputName: 'color',
                              },
                            ],
                            dropDown: false,
                            styles: {
                              marginTop: '16px',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            },
                          },
                        ],
                        dropDown: true,
                      },
                    ],
                    dropDown: true,
                  },
                ],
                dropDown: true,
              },
            ],
            dropDown: true,
          },
        ],
        dropDown: true,
      },
    ],
  },
  html: '<link href="https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,100;0,300;0,400;0,500;0,700;1,100;1,300;1,400;1,500;1,700&amp;display=swap" rel="stylesheet"><style>\n  @media (max-width: 767px) {\n    .block{\n      flex-wrap: wrap !important;\n    }\n    .block>div{\n      width: 100% !important;\n    }\n  }\n  </style><div class="body false" style="background-repeat: no-repeat; background-color: rgb(255, 255, 255); overflow: auto; font-family: Ubuntu; color: rgb(0, 0, 0); border-style: none;"><div class="block cd false false" style="display: flex; flex-direction: row; height: 100vh; background-repeat: no-repeat; transition: 0.1s; color: inherit; width: 100%;"><div class="block cd false false" style="display: flex; flex-direction: column; height: 100%; background-repeat: no-repeat; transition: 0.1s; color: inherit; background-size: cover; align-items: center; justify-content: center; width: 50%; position: relative;"><div class="element cd false" contenteditable="false" style="color: rgb(0, 0, 0); font-size: 32px; font-weight: 600; position: relative; z-index: 1;">HEADING</div><div class="element cd false" contenteditable="false" style="color: rgb(0, 0, 0); text-align: center; position: relative; z-index: 1;">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</div><video class="element cd focused" autoplay="" loop="" playsinline="" src="https://videos.pexels.com/video-files/3755797/3755797-uhd_2732_1440_25fps.mp4" style="width: 100%; height: 100%; position: absolute; top: 0px; object-fit: cover;"></video></div><div class="block cd false false" style="display: flex; flex-direction: row; height: 100%; background-repeat: no-repeat; transition: 0.1s; color: inherit; padding: 26px; align-items: center; justify-content: center; width: 50%;"><div class="block cd false false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; border-radius: 12px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.2); width: 80%; padding: 26px 24px;"><div class="element cd false" contenteditable="false" style="font-weight: 600; font-size: 24px; margin-bottom: 22px; padding: 10px;">Create An Account</div><form class="element cd false"><div class="stepper cd"><div class="stepWrapper"><div class="stepCircle" style="background-color: rgb(191, 219, 254); color: rgb(29, 78, 216);">1</div><div class="connector" style="background-color: rgb(229, 231, 235);"></div><div class="stepLabel" style="color: rgb(59, 130, 246);">Step 4</div></div><div class="stepWrapper"><div class="stepCircle" style="background-color: rgb(229, 231, 235); color: rgb(107, 114, 128);">2</div><div class="connector" style="background-color: rgb(229, 231, 235);"></div><div class="stepLabel" style="color: rgb(229, 231, 235);">Step 2</div></div><div class="stepWrapper"><div class="stepCircle" style="background-color: rgb(229, 231, 235); color: rgb(107, 114, 128);">3</div><div class="stepLabel" style="color: rgb(229, 231, 235);">Step 3</div></div></div><div class="stepContent"><div class="block cd false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; padding: 16px;"><div class="block cd false false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit;"><label class="element cd false" contenteditable="false" for="email" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Email</label><input class="element cd false" name="email" id="email" placeholder="Enter your email" type="email" required="" data-field-id="email" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div><div class="block cd false false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; margin-top: 16px;"><label class="element cd false" contenteditable="false" for="phone" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Phone</label><input class="element cd false" name="phone" id="phone" placeholder="Enter your phone" type="tel" required="" data-field-id="phone" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div><div class="block cd false false" style="display: flex; flex-direction: row; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; margin-top: 16px; margin-left: -10px; margin-right: -10px; align-items: center; justify-content: center;"><div class="block cd false false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; padding-left: 10px; padding-right: 10px; width: 50%;"><label class="element cd false" contenteditable="false" for="password" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Password</label><input class="element cd false" name="password" id="password" placeholder="Enter your password" type="password" required="" data-field-id="password" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div><div class="block cd false false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; padding-left: 10px; padding-right: 10px; width: 50%;"><label class="element cd false" contenteditable="false" for="confirmPassword" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Confirm Password</label><input class="element cd false" name="confirmPassword" id="confirmPassword" placeholder="Confirm your password" type="password" required="" data-field-id="confirmPassword" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"></div></div><div class="block cd false false" style="display: flex; flex-direction: row; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; margin-top: 16px; align-items: center; justify-content: flex-start;"><input class="element cd false" name="terms" id="terms" placeholder="Enter your phone" type="checkbox" required="" data-field-id="terms" value="" style="border-radius: 8px; font-size: 16px; padding: 6px 16px; border-style: solid; border-width: 1px; border-color: rgba(0, 0, 0, 0.36);"><label class="element cd false" contenteditable="false" for="terms" style="font-size: 14px; padding-left: 6px; margin-bottom: 3px;">Accept terms</label></div></div></div><div class="block cd false" style="display: flex; flex-direction: row; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; margin-top: 32px; padding-left: 16px; padding-right: 16px;"><button id="prevButton" class="element cd false" contenteditable="false" style="padding-left: 18px; padding-right: 18px; border-radius: 12px; background-color: rgb(247, 246, 251); display: block;">Back</button><button id="nextButton" class="element cd false" contenteditable="false" style="margin-left: auto; border-radius: 12px; padding-left: 18px; padding-right: 18px; background-color: rgb(191, 177, 255); color: rgb(255, 255, 255); display: block;">Next</button></div></form></div></div></div></div>',
}
